"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useAppSelector } from "@/redux/hooks";
import { getInitials } from "@/utils/global";
import { isTeamVisibility } from "@/types/visibility";

interface IntegrationOwnershipIndicatorProps {
  owner?: IntegrationOwner | null;
  visibility?: AppIntegrationVisibility;
}

export function IntegrationOwnershipBadge({
  owner,
  visibility,
}: IntegrationOwnershipIndicatorProps) {
  const currentUserId = useAppSelector((state) => state.user.user?.id ?? null);
  const isOwnedByCurrentUser = Boolean(owner && currentUserId && owner.id === currentUserId);

  if (owner && currentUserId && !isOwnedByCurrentUser) {
    return (
      <div
        className="inline-flex max-w-full items-center gap-1 rounded-full border bg-muted/40 px-2 py-0.5 text-[10px] font-medium text-muted-foreground"
        title={`Shared by ${owner.fullname ?? "another user"}`}
      >
        <Avatar className="h-4 w-4 shrink-0">
          <AvatarImage
            src={owner.profile_image_url ?? ""}
            alt={owner.fullname ?? undefined}
          />
          <AvatarFallback className="text-[8px]">
            {getInitials(owner.fullname ?? "Owner")}
          </AvatarFallback>
        </Avatar>
        <span className="truncate">Shared by {owner.fullname ?? "another user"}</span>
      </div>
    );
  }

  if (isOwnedByCurrentUser) {
    return null;
  }

  if (visibility != null) {
    return (
      <span className="inline-flex max-w-full items-center rounded-full border bg-muted/40 px-2 py-0.5 text-[10px] font-medium text-muted-foreground">
        {isTeamVisibility(visibility) ? "Shared" : "Personal"}
      </span>
    );
  }

  return null;
}
